import { Component } from '@angular/core';

@Component({
  selector: 'app-vehicle-no-selected',
  templateUrl: './vehicle-no-selected.component.html',
  styleUrls: ['./vehicle-no-selected.component.css'],
})
export class VehicleNoSelectedComponent {}
